import { Injectable } from '@angular/core';
import { nanoid } from 'nanoid';

@Injectable({
  providedIn: 'root',
})
export class StatesService {
  constructor() {}

  onFocus(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }
    if (!statesObject.activeStates) {
      statesObject.activeStates = [];
    }
    if (!statesObject.activeStates.includes('focus')) {
      statesObject.activeStates.push('focus');
    }
    component.stateRef = nanoid();
  }
  onBlur(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }

    // remove focus
    let deleteDex = -1;
    statesObject?.activeStates?.forEach((stateName: string, index: number) => {
      if (stateName == 'focus') {
        deleteDex = index;
      }
    });
    if (deleteDex > -1) {
      statesObject.activeStates.splice(deleteDex, 1);
    }
    component.stateRef = nanoid();
  }
  onFocusOut(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }

    // remove focus
    let deleteDex = -1;
    statesObject?.activeStates?.forEach((stateName: string, index: number) => {
      if (stateName == 'focus') {
        deleteDex = index;
      }
    });
    if (deleteDex > -1) {
      statesObject.activeStates.splice(deleteDex, 1);
    }
    component.stateRef = nanoid();
  }

  onMouseDown(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }

    if (!statesObject.activeStates) {
      statesObject.activeStates = [];
    }
    if (!statesObject.activeStates.includes('active')) {
      statesObject.activeStates.push('active');
    }
    if (!statesObject.activeStates.includes('visited')) {
      statesObject.activeStates.push('visited');
    }
    component.stateRef = nanoid();
  }
  onMouseUp(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }
    // remove focus
    let deleteDex = -1;
    statesObject?.activeStates?.forEach((stateName: string, index: number) => {
      if (stateName == 'active') {
        deleteDex = index;
      }
    });
    if (deleteDex > -1) {
      statesObject.activeStates.splice(deleteDex, 1);
    }
    component.stateRef = nanoid();
  }

  onMouseEnter(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }
    if (!statesObject.activeStates) {
      statesObject.activeStates = [];
    }
    if (!statesObject.activeStates.includes('hover')) {
      statesObject.activeStates.push('hover');
    }
    component.stateRef = nanoid();
  }
  onMouseLeave(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }
    let deleteDex: any = [];
    statesObject?.activeStates?.forEach((stateName: string, index: number) => {
      if (stateName == 'hover') {
        deleteDex.push(index);
      }
    });
    if (deleteDex.length > 0) {
      deleteDex.forEach((_deleteDex: any) => {
        statesObject.activeStates.splice(_deleteDex, 1);
      });
    }
  }

  onDragStart(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }
    if (!statesObject.activeStates) {
      statesObject.activeStates = [];
    }
    if (!statesObject.activeStates.includes('dragging')) {
      statesObject.activeStates.push('dragging');
    }
    component.stateRef = nanoid();
  }

  onDragEnd(component: any, statesObject?: any) {
    if (!statesObject) {
      statesObject = component;
    }

    if (!statesObject.activeStates) {
      statesObject.activeStates = [];
    }
    if (!statesObject.activeStates.includes('dropped')) {
      statesObject.activeStates.push('dropped');
    }

    let deleteDex = -1;
    statesObject?.activeStates?.forEach((stateName: string, index: number) => {
      if (stateName == 'dragging') {
        deleteDex = index;
      }
    });
    if (deleteDex > -1) {
      statesObject.activeStates.splice(deleteDex, 1);
    }
    component.stateRef = nanoid();
  }

  getComponentState(statesObject: any, component?: any) {
    let currentState: any = null;
    if (!component) {
      component = statesObject;
    }
    if (component.currentState) {
      component?.states?.forEach((_state: any) => {
        if (_state.id == component.currentState) {
          currentState = _state;
        }
      });
    }
    if (statesObject?.activeStates?.length > 0 && !currentState?.override) {
      let currentStateName = '';
      // what is the order?
      if (statesObject.activeStates.includes('dragging')) {
        currentStateName = 'dragging';
      } else if (statesObject.activeStates.includes('active')) {
        currentStateName = 'active';
      } else if (statesObject.activeStates.includes('hover')) {
        currentStateName = 'hover';
      } else if (statesObject.activeStates.includes('focus')) {
        currentStateName = 'focus';
      } else if (statesObject.activeStates.includes('dropped')) {
        currentStateName = 'dropped';
      } else if (statesObject.activeStates.includes('visited')) {
        currentStateName = 'visited';
      }
      if (currentStateName) {
        component?.states?.forEach((_state: any) => {
          if (_state.name == currentStateName) {
            currentState = _state;
          }
        });
      }
    } else {
      //component.currentState = null;
    }
    return currentState;
  }

  getComponentStateById(component: any, stateId: string) {
    let currentState: any;
    component.states.forEach((state: any) => {
      if (state.id == stateId) {
        currentState = state;
      }
    });
    return currentState;
  }

  clearStates(statesObject: any, states: any) {
    let deleteDex: any = [];
    statesObject?.activeStates?.forEach((stateName: string, index:number) => {
      if (states.indexOf(stateName) !=-1) {
        deleteDex.push(index);
      }
    });

    if (deleteDex.length > 0) {
      deleteDex.forEach((_deleteDex: any) => {
        statesObject.activeStates.splice(_deleteDex, 1);
      });
    }
  }
}
